import Index from '@/views/clubs/Index'
import Create from '@/views/clubs/Create'
import Edit from '@/views/clubs/Edit'
import Merge from '@/views/clubs/Merge.vue'

export default [
  {
    path: ':clientId/clubs',
    name: 'clubs.index',
    component: Index
  },
  {
    path: ':clientId/clubs/create',
    name: 'clubs.create',
    component: Create,
    meta: {
      title: 'Create club',
      breadcrumb: [
        {
          name: 'Clubs',
          route: {
            name: 'clubs.index'
          }
        },
        {
          name: 'Create'
        }
      ]
    }
  },
  {
    path: ':clientId/clubs/merge',
    name: 'clubs.merge',
    component: Merge,
    meta: {
      title: 'Merge clubs',
      breadcrumb: [
        {
          name: 'Clubs',
          route: {
            name: 'clubs.index'
          }
        },
        {
          name: 'Merge'
        }
      ]
    }
  },
  {
    path: ':clientId/clubs/:uuid',
    name: 'clubs.edit',
    component: Edit,
    meta: {
      title: 'Edit club',
      breadcrumb: [
        {
          name: 'Clubs',
          route: {
            name: 'clubs.index'
          }
        },
        {
          name: 'Edit'
        }
      ]
    }
  }
]
